import {filesize} from "filesize";
import {useTranslation} from "react-i18next";

/**
 * @param {number} children
 * */
export function FileSize({children}) {
    const {t} = useTranslation();
    return (
        <span className="file-size">
            {
                filesize(children, {
                    standard: 'iec',
                    locale: t('BCP47LOCALE'),
                })
            }
        </span>
    );
}
